function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 56,
  cy: 65.5,
  rx: 48,
  ry: 57.5,
  fill: "#67B360"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M103 18C103 8.05887 94.9411 0 85 0H64C54.0589 0 46 8.05887 46 18V36H85C94.9411 36 103 27.9411 103 18V18Z",
  fill: "#ED3E3E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.744 12.84C62.76 12.496 62.84 12.324 62.984 12.324C63.136 12.324 63.3 12.416 63.476 12.6C63.652 12.784 63.74 12.948 63.74 13.092C63.74 13.748 63.636 14.68 63.428 15.888C63.228 17.096 62.956 18.216 62.612 19.248C62.276 20.28 61.956 20.796 61.652 20.796C61.548 20.796 61.428 20.744 61.292 20.64C61.164 20.536 61.064 20.408 60.992 20.256C60.752 19.696 60.044 17.92 58.868 14.928C58.628 15.856 58.36 16.908 58.064 18.084C57.776 19.252 57.584 19.996 57.488 20.316C57.392 20.636 57.308 20.796 57.236 20.796C57.132 20.796 57.004 20.708 56.852 20.532C56.708 20.348 56.636 20.16 56.636 19.968C56.636 19.776 56.896 18.652 57.416 16.596C57.936 14.532 58.204 13.244 58.22 12.732C58.22 12.476 58.288 12.348 58.424 12.348C58.512 12.348 58.632 12.424 58.784 12.576C58.944 12.72 59.06 12.88 59.132 13.056C60.42 16.4 61.236 18.448 61.58 19.2C62.1 17.824 62.448 16.18 62.624 14.268C62.704 13.388 62.744 12.912 62.744 12.84ZM68.1171 16.908C68.1171 16.636 68.0731 16.38 67.9851 16.14C67.8971 15.892 67.7691 15.712 67.6011 15.6C67.0491 15.752 66.5731 16.18 66.1731 16.884C65.7811 17.58 65.5851 18.236 65.5851 18.852C65.5851 19.468 65.7371 19.852 66.0411 20.004C66.6171 19.892 67.1051 19.5 67.5051 18.828C67.9131 18.148 68.1171 17.508 68.1171 16.908ZM64.9611 17.016C65.2411 16.392 65.6051 15.88 66.0531 15.48C66.5091 15.072 66.9731 14.868 67.4451 14.868C67.9251 14.868 68.3251 15.072 68.6451 15.48C68.9651 15.88 69.1251 16.372 69.1251 16.956C69.1251 17.532 68.9851 18.124 68.7051 18.732C68.4251 19.332 68.0371 19.832 67.5411 20.232C67.0531 20.624 66.5331 20.82 65.9811 20.82C65.5731 20.82 65.2331 20.632 64.9611 20.256C64.6891 19.88 64.5531 19.404 64.5531 18.828C64.5531 18.244 64.6891 17.64 64.9611 17.016ZM71.4666 13.164C71.4666 13.004 71.5306 12.852 71.6586 12.708C71.7866 12.564 71.9146 12.492 72.0426 12.492C72.1786 12.492 72.3386 12.656 72.5226 12.984C72.7066 13.304 72.7986 13.572 72.7986 13.788C72.7986 13.868 72.7626 13.94 72.6906 14.004C72.6186 14.068 72.5426 14.1 72.4626 14.1C72.2706 14.1 72.0546 13.984 71.8146 13.752C71.5826 13.52 71.4666 13.324 71.4666 13.164ZM71.4066 14.868C71.5586 14.868 71.7026 14.96 71.8386 15.144C71.9746 15.328 72.0426 15.508 72.0426 15.684C72.0426 15.86 71.9266 16.388 71.6946 17.268C71.4626 18.14 71.1706 19.12 70.8186 20.208C70.6826 20.608 70.5106 20.808 70.3026 20.808C70.1906 20.808 70.0946 20.764 70.0146 20.676C69.9346 20.58 69.8946 20.476 69.8946 20.364C69.8946 20.244 69.9226 20.06 69.9786 19.812C70.0426 19.556 70.1306 19.22 70.2426 18.804C70.3626 18.38 70.4546 18.036 70.5186 17.772C70.5906 17.508 70.6626 17.212 70.7346 16.884C70.8066 16.548 70.8626 16.28 70.9026 16.08C70.9506 15.872 71.0026 15.664 71.0586 15.456C71.1706 15.064 71.2866 14.868 71.4066 14.868ZM74.722 20.82C74.258 20.82 73.822 20.64 73.414 20.28C73.006 19.912 72.802 19.48 72.802 18.984C72.802 18.48 72.97 17.9 73.306 17.244C73.642 16.588 74.074 16.028 74.602 15.564C75.138 15.1 75.658 14.868 76.162 14.868C76.49 14.868 76.778 15.016 77.026 15.312C77.274 15.608 77.398 15.868 77.398 16.092C77.398 16.156 77.378 16.212 77.338 16.26C77.298 16.3 77.238 16.32 77.158 16.32C77.086 16.32 76.954 16.248 76.762 16.104C76.57 15.96 76.398 15.888 76.246 15.888C75.814 15.888 75.31 16.268 74.734 17.028C74.158 17.788 73.87 18.452 73.87 19.02C73.87 19.268 73.946 19.464 74.098 19.608C74.258 19.752 74.51 19.824 74.854 19.824C75.206 19.824 75.526 19.784 75.814 19.704C76.11 19.616 76.338 19.532 76.498 19.452C76.658 19.364 76.782 19.32 76.87 19.32C77.022 19.32 77.098 19.396 77.098 19.548C77.098 19.78 76.818 20.052 76.258 20.364C75.706 20.668 75.194 20.82 74.722 20.82ZM82.9217 16.86C82.9217 17.284 82.6897 17.632 82.2257 17.904C81.7697 18.168 81.2497 18.3 80.6657 18.3C80.0897 18.3 79.5657 18.236 79.0937 18.108C78.9817 18.46 78.9257 18.776 78.9257 19.056C78.9257 19.328 79.0097 19.54 79.1777 19.692C79.3537 19.844 79.6377 19.92 80.0297 19.92C80.4297 19.92 80.8377 19.852 81.2537 19.716C81.6777 19.572 81.9097 19.5 81.9497 19.5C82.1577 19.5 82.2617 19.58 82.2617 19.74C82.2617 19.956 82.0177 20.192 81.5297 20.448C81.0417 20.696 80.5657 20.82 80.1017 20.82C79.4777 20.82 78.9697 20.636 78.5777 20.268C78.1857 19.892 77.9897 19.42 77.9897 18.852C77.9897 18.284 78.1417 17.692 78.4457 17.076C78.7497 16.452 79.1417 15.928 79.6217 15.504C80.1017 15.08 80.5777 14.868 81.0497 14.868C81.5217 14.868 81.9497 15.092 82.3337 15.54C82.7257 15.988 82.9217 16.428 82.9217 16.86ZM81.1097 15.816C80.8137 15.816 80.5057 15.972 80.1857 16.284C79.8657 16.588 79.5937 16.968 79.3697 17.424C79.6897 17.496 80.0537 17.532 80.4617 17.532C80.8697 17.532 81.2257 17.468 81.5297 17.34C81.8337 17.204 81.9857 17.028 81.9857 16.812C81.9857 16.596 81.8857 16.376 81.6857 16.152C81.4937 15.928 81.3017 15.816 81.1097 15.816ZM84.9041 21.072C84.7041 21.072 84.4761 20.944 84.2201 20.688C83.9641 20.424 83.8361 20.208 83.8361 20.04C83.8361 19.864 83.9041 19.692 84.0401 19.524C84.1841 19.348 84.3281 19.26 84.4721 19.26C84.6241 19.26 84.7961 19.456 84.9881 19.848C85.1881 20.24 85.2881 20.536 85.2881 20.736C85.2881 20.8 85.2441 20.872 85.1561 20.952C85.0681 21.032 84.9841 21.072 84.9041 21.072Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 11.0835,
  height: 6.9464,
  transform: "matrix(-0.784456 -0.620184 -0.583906 0.811821 45.7505 120.874)",
  fill: "#ED3E3E"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 44.3082,
  height: 78,
  rx: 22,
  transform: "matrix(-1 0 0 1 44.3081 25)",
  fill: "#F3F3F3"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 8.34591,
  height: 1.25,
  transform: "matrix(-1 0 0 1 38.6519 54)",
  fill: "#004122"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 8.34591,
  height: 1.25,
  transform: "matrix(-1 0 0 1 19.7974 53)",
  fill: "#004122"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 12.8932,
  height: 22,
  transform: "matrix(-1 0 0 1 40.8931 62)",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 9.66989,
  height: 14.6667,
  transform: "matrix(-1 0 0 1 37.6699 62)",
  fill: "#004122"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 3.2233,
  height: 3.66667,
  transform: "matrix(-1 0 0 1 32.835 63.8334)",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 14.3627,
  height: 22,
  transform: "matrix(-1 0 0 1 25.4536 62)",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 10.772,
  height: 14.6667,
  transform: "matrix(-1 0 0 1 21.8628 62)",
  fill: "#004122"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 3.59068,
  height: 3.66667,
  transform: "matrix(-1 0 0 1 16.4771 63.8334)",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2893 87.5625L25.8282 94.8405L17.3671 87.5625H34.2893Z",
  fill: "white",
  stroke: "#004122"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  width: 28.2818,
  height: 21,
  rx: 10.5,
  transform: "matrix(-1 0 0 1 36.7666 109)",
  fill: "#ED3E3E"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  width: 9.78818,
  height: 6.9464,
  transform: "matrix(-0.784456 -0.620184 -0.583906 0.811821 37.7344 126.07)",
  fill: "#ED3E3E"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 20L29.8612 26H15.1388L22.5 20Z",
  fill: "#004122"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 128.723,
  width: 7,
  height: 4,
  transform: "rotate(-22.8959 47 128.723)",
  fill: "#004122"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 57.813,
  y: 123,
  width: 7,
  height: 4,
  transform: "rotate(26.9487 57.813 123)",
  fill: "#004122"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 117.768,
  width: 13.9552,
  height: 8.423,
  transform: "rotate(-11.4394 41 117.768)",
  fill: "#004122"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 54.8027,
  y: 132.949,
  width: 7,
  height: 4,
  transform: "rotate(7.15106 54.8027 132.949)",
  fill: "#004122"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.5,
  cy: 119.5,
  r: 1.5,
  fill: "#ED3E3E"
});

function SvgKlemen2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 138,
    viewBox: "0 0 104 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlemen2);
export default __webpack_public_path__ + "static/media/klemen_2.1c64f88a.svg";
export { ForwardRef as ReactComponent };